/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    TravelErrorHeader1: {
        id: 'qnb.spt.errorPage.TravelErrorHeader1',
        defaultMessage: 'Thank you for your interest in Saga Travel Insurance.'
    },
    TravelErrorHeader2: {
        id: 'qnb.spt.errorPage.TravelErrorHeader2',
        defaultMessage: 'What happens next?'
    },
    TravelErrorHeader3: {
        id: 'qnb.spt.errorPage.TravelErrorHeader3',
        defaultMessage: 'Thank you for visiting Saga…'
    },
    TravelErrorText1: {
        id: 'qnb.spt.errorPage.TravelErrorText1',
        defaultMessage: 'Unfortunately, we are not able to offer cover on this occasion as you have told us you have received a terminal illness/prognosis and/or you will be travelling against your UK doctor\'s advice. We would like to make you aware of the Money Helper Travel Insurance Directory. This is a directory of specialist insurers who may be able to offer you cover, details of which can be found {link}, or you can call them directly on 0800 138 7777 to discuss further options.'
    },
    TravelErrorText2: {
        id: 'qnb.spt.errorPage.TravelErrorText2',
        defaultMessage: 'Unfortunately, we are unable to offer cover on this occasion as you have told us you are on a waiting list/need in-patient or out-patient treatment for an undiagnosed condition. We would like to make you aware of the Money Helper Travel Insurance Directory. This is a directory of specialist insurers who may be able to offer you cover, details of which can be found {link}, or you can call them directly on 0800 138 7777 to discuss further options.'
    },
    TravelErrorText3: {
        id: 'qnb.spt.errorPage.TravelErrorText3',
        defaultMessage: 'You have told us you are currently undergoing medical investigation or awaiting test results.'
    },
    TravelErrorText4: {
        id: 'qnb.spt.errorPage.TravelErrorText4',
        defaultMessage: 'If these are related to a diagnosed condition, please call us on 0800 015 8055 to complete your quote.'
    },
    TravelErrorText5: {
        id: 'qnb.spt.errorPage.TravelErrorText5',
        defaultMessage: 'If these are related to an undiagnosed condition, we\'re sorry that we cannot offer you a quote until you have your diagnosis confirmed.'
    },
    TravelErrorText6: {
        id: 'qnb.spt.errorPage.TravelErrorText6',
        defaultMessage: 'If you need cover now, take a look at the {link}. Some of the specialist insurance providers listed may be able to offer you cover. You can phone 0800 138 7777 to discuss your options.'
    },
    TravelErrorText7: {
        id: 'qnb.spt.errorPage.TravelErrorText7',
        defaultMessage: 'Unfortunately, we are not able to offer cover on this occasion. We would like to make you aware of the Money Helper Travel Insurance Directory. This is a directory of specialist insurers who may be able to offer you cover, details of which can be found {link}, or you can call them directly on 0800 138 7777 to discuss further options.'
    },
    TravelErrorHere: {
        id: 'qnb.spt.errorPage.TravelErrorHere',
        defaultMessage: 'here'
    },
    TravelErrorHeaderPayment: {
        id: 'qnb.spt.errorPage.TravelErrorHeaderPayment',
        defaultMessage: 'Sorry there has been a problem in trying to take payment for your Saga Insurance'
    },
    TravelErrorPaymentText1: {
        id: 'qnb.spt.errorPage.TravelErrorPaymentText1',
        defaultMessage: 'We have not been able to complete your policy purchase.'
    },
    TravelErrorPaymentText2: {
        id: 'qnb.spt.errorPage.TravelErrorPaymentText2',
        defaultMessage: 'Please call 0800 904 7489 and speak to one of our agents who will be able to help.'
    },
    TravelErrorPaymentText3: {
        id: 'qnb.spt.errorPage.TravelErrorPaymentText3',
        defaultMessage: 'Our lines are open 8.30am to 7pm weekdays, and 8.30am to 5pm Saturdays.'
    },
    TravelErrorMoneyHelperDirectory: {
        id: 'qnb.spt.errorPage.TravelErrorMoneyHelperDirectory',
        defaultMessage: 'Money Helper Travel Insurance Directory'
    },
    TravelErrorHomeButton: {
        id: 'qnb.spt.errorPage.TravelErrorHomeButton',
        defaultMessage: 'Saga homepage'
    },
    TravelTiaRetrievalErrorHeader: {
        id: 'qnb.spt.errorPage.TravelTiaRetrievalErrorHeader',
        defaultMessage: 'We have been unable to retrieve your quote online'
    },
    TravelTiaRetrievalErrorMessage: {
        id: 'qnb.spt.errorPage.TravelTiaRetrievalErrorMessage',
        defaultMessage: 'We have made changes to our website and as a result are unable to retrieve your quote online. Please {link}.'
    },
    TravelTiaRetrievalStartNewQuote: {
        id: 'qnb.spt.errorPage.TravelTiaRetrievalStartNewQuote',
        defaultMessage: 'start a new quote'
    },
    TravelGenericErrorMessageText1: {
        id: 'qnb.spt.errorPage.TravelGenericErrorMessageText1',
        defaultMessage: 'Sorry, something\'s gone wrong with our website.'
    },
    TravelGenericErrorMessageText2: {
        id: 'qnb.spt.errorPage.TravelGenericErrorMessageText2',
        defaultMessage: 'Please give us a call on <strong>0800 015 8055</strong> to continue with your request'
    },
    TravelGenericErrorMessageText3: {
        id: 'qnb.spt.errorPage.TravelGenericErrorMessageText3',
        defaultMessage: 'Our lines are open 8.30am to 7pm weekdays, and 8.30am to 5pm Saturdays.'
    },
    TravelFraudulentCardMessageText1: {
        id: 'qnb.spt.errorPage.TravelFraudulentCardMessageText1',
        defaultMessage: 'It looks like we\'ve had a problem taking your payment.'
    },
    TravelFraudulentCardMessageText2: {
        id: 'qnb.spt.errorPage.TravelFraudulentCardMessageText2',
        defaultMessage: 'Please contact us on 0800 056 9273 to discuss further.'
    },
    TravelFraudulentCardMessageText3: {
        id: 'qnb.spt.errorPage.TravelFraudulentCardMessageText3',
        defaultMessage: 'Your account will not be charged but it may show as a pending transaction for up to 24 hours.'
    },
    TravelRetrievalErrorHeader: {
        id: 'qnb.spt.errorPage.TravelRetrievalErrorHeader',
        defaultMessage: 'Thank you for your interest in Saga\'s Travel Insurance'
    },
    TravelRetrievalErrorText: {
        id: 'qnb.spt.errorPage.TravelRetrievalErrorText',
        defaultMessage: 'Sorry, we have been unable to retrieve your quote. If you have any questions or would like to discuss your policy, please call us on 0800&nbsp;904&nbsp;7489.'
    },
    TravelReferralErrorText1: {
        id: 'qnb.spt.errorPage.TravelReferralErrorText1',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to complete your online quotation'
    },
    TravelReferralErrorText2: {
        id: 'qnb.spt.errorPage.TravelReferralErrorText2',
        defaultMessage: 'You can give us a call and one of our customer service advisers will be happy to help'
    },
    TravelDeclineDefaultMessage: {
        id: 'qnb.spt.errorPage.TravelDeclineDefaultMessage',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to offer you a quotation.'
    },
    ExistingCustomerHeader: {
        id: 'qnb.spt.error.ExistingCustomerHeader',
        defaultMessage: 'Are you an existing customer?'
    },
    ExistingCustomerAnswer0: {
        id: 'qnb.spt.error.ExistingCustomerAnswer0',
        defaultMessage: 'Yes, I\'m thinking about renewing my policy'
    },
    ExistingCustomerAnswer0Content1: {
        id: 'qnb.spt.error.ExistingCustomerAnswer0Content1',
        defaultMessage: 'We send renewal documents out at least 21 days before your renewal is due. If you\'d like to talk to us about your renewal, we\'ll be happy to help - just call us free on '
    },
    ExistingCustomerAnswer0Content2: {
        id: 'qnb.spt.error.ExistingCustomerAnswer0Content2',
        defaultMessage: '0800 904 7764.'
    },
    ExistingCustomerAnswer0Content3: {
        id: 'qnb.spt.error.ExistingCustomerAnswer0Content3',
        defaultMessage: 'Our lines are open <strong>8.30am to 7pm weekdays</strong>, and <strong>9am to 5pm Saturdays</strong>.'
    },
    ExistingCustomerAnswer0Content4: {
        id: 'qnb.spt.error.ExistingCustomerAnswer0Content4',
        defaultMessage: '<strong>Important:</strong> if you don\'t want to continue with your Saga policy, please let us know before your renewal date.'
    },
    ExistingCustomerAnswer1: {
        id: 'qnb.spt.error.ExistingCustomerAnswer1',
        defaultMessage: 'Yes, I\'m thinking about making some changes to my policy'
    },
    ExistingCustomerAnswer1Content1: {
        id: 'qnb.spt.error.ExistingCustomerAnswer1Content1',
        defaultMessage: 'To find out more about making changes to your policy, please visit the policy details section of our website '
    },
    Here: {
        id: 'qnb.spt.error.Here',
        defaultMessage: 'here'
    },
    ExistingCustomerAnswer1Content2: {
        id: 'qnb.spt.error.ExistingCustomerAnswer1Content2',
        defaultMessage: 'Alternatively, if you would like to speak to one of our customer service advisers call us free on'
    },
    ExistingCustomerAnswer1Content3: {
        id: 'qnb.spt.error.ExistingCustomerAnswer1Content3',
        defaultMessage: ' 0800 056 9200.'
    },
    ExistingCustomerAnswer1Content4: {
        id: 'qnb.spt.error.ExistingCustomerAnswer1Content4',
        defaultMessage: 'Our lines are open <strong>8.30am to 7pm weekdays</strong>, and <strong>9am to 5pm Saturdays</strong>.'
    },
    ExistingCustomerAnswer2: {
        id: 'qnb.spt.error.ExistingCustomerAnswer2',
        defaultMessage: 'No, I am not currently insured with Saga'
    },
    ExistingCustomerAnswer2Content1: {
        id: 'qnb.spt.error.ExistingCustomerAnswer2Content1',
        defaultMessage: 'Don\'t worry - there are sometimes circumstances in which we can\'t provide a quote online, but can over the phone.'
    },
    ExistingCustomerAnswer2Content2: {
        id: 'qnb.spt.error.ExistingCustomerAnswer2Content2',
        defaultMessage: 'Please call us free on <strong>0800 015 8055</strong> - we\'ll be happy to help.'
    },
    ExistingCustomerAnswer2Content3: {
        id: 'qnb.spt.error.ExistingCustomerAnswer2Content3',
        defaultMessage: 'Our lines are open <strong>8.30am to 7pm weekdays</strong>, and <strong>8.30am to 5pm Saturdays</strong>.'
    },
    SagaHomepage: {
        id: 'qnb.spt.error.SagaHomepage',
        defaultMessage: 'Saga homepage'
    },
    CallUsOn: {
        id: 'qnb.spt.error.CallUsOn',
        defaultMessage: 'Call us on {number}'
    },
});
